import { SETTLEMENTS_ACTION_TYPES } from '../../actions/settlementsActions';

const initialState = {
  settlements: [],
  loading: false,
  error: null
};

const settlementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTLEMENTS_ACTION_TYPES.LOAD_SETTLEMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case SETTLEMENTS_ACTION_TYPES.LOAD_SETTLEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        settlements: action.payload
      };

    case SETTLEMENTS_ACTION_TYPES.LOAD_SETTLEMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default settlementsReducer;
